import { PharmaciesActionTypes } from './pharmacies-actions';
import nationalIdValidation from '@utils/helpers/national-id-validation';
import saveToLocal from '@utils/storage/save-to-local';

export const initialState = {
  hashedPharmacyId: undefined,
  selectedServiceDescription: [],
  pharmacyFile: undefined,
  serviceTypeTitle: 'داروخانه',
  pharmacyText: '',
  gender: null,
  genderFlag: false,
  genderError: false,
  applicantValidation: false,
  recipients: {
    '1': '',
  },
  recipientsValidation: false,
  recipientsError: false,
  clientSuggestedType: '1',
  clientSuggestedTime: undefined,
  clientSuggestedRange: undefined,
  storePharmacyLoading: false,
  otcList: [{
    name: '',
    key: new Date().getTime(),
    quantity: '',
    doze: '',
    description: '',
    drugTitleFlag: false,
    drugTypeFlag: false,
    drugUnitFlag: false,
    drugQuantityFlag: false,
    attach: null,
    type: '',
    unit: '',
    sending_similar: '0',
    isLocked: false,
    isLoading: false,
  }],
  otcCardFlag: true,
  moduleName: undefined,
  pharmacyEditedImage: undefined,
  pharmacyEditedImageIndex: 0,
  pharmacyImageLoading: false,
  showBanner: true,
  otcValidationId: null,
  otcValidationInfo: null,
  disableOtcFlag: false,
  city: {
    id: undefined,
    name: undefined,
    title: undefined,
  },
  cityModal: false,
  cityHref: '',
  checkDrugLoading: false,

  validationType: null,
  pharmacyLoading: false,
  electronicPrescription: {
    insurance_type: '',
    national_code: '',
    tracking_code: '',
    doctor_name: '',
    description: '',
    insuranceFlag: false,
    nationalFlag: false,
    trackingFlag: false,
    doctorFlag: false,
  },
  insuranceList: [],
  insuranceListLoading: false,
  electronicPrescriptionFlag: false,
  bannerPrice: 0,
  bannerLoading: true,
};

function pharmaciesReducer(state = initialState, action: any) {
  switch (action.type) {
    case PharmaciesActionTypes.SET_INITIAL_STORE:
      return {
        ...state,
        selectedServiceDescription: [],
        pharmacyFile: undefined,
        serviceTypeTitle: 'داروخانه',
        pharmacyText: '',
        applicantValidation: false,
        recipients: {
          '1': '',
        },
        recipientsValidation: false,
        recipientsError: false,
        clientSuggestedType: '1',
        clientSuggestedTime: undefined,
        clientSuggestedRange: undefined,
        storePharmacyLoading: false,
        otcList: [{
          name: '',
          key: new Date().getTime(),
          quantity: '',
          doze: '',
          description: '',
          drugTitleFlag: false,
          drugTypeFlag: false,
          drugUnitFlag: false,
          drugQuantityFlag: false,
          type: '',
          unit: '',
          sending_similar: '0',
          isLocked: false,
        }],
        otcCardFlag: true,
        moduleName: undefined,
        electronicPrescription: {
          insurance_type: '',
          national_code: '',
          tracking_code: '',
          doctor_name: '',
          description: '',
          insuranceFlag: false,
          nationalFlag: false,
          trackingFlag: false,
          doctorFlag: false,
        },
      };

    case PharmaciesActionTypes.SET_HASHED_PHARMACY_ID:
      return {
        ...state,
        hashedPharmacyId: action?.data?.hashedPharmacyId,
      };

    case PharmaciesActionTypes.SET_DESCRIPTION:
      return {
        ...state,
        selectedServiceDescription: action?.data?.selectedServiceDescription,
      };

    case PharmaciesActionTypes.SET_PHARMACY_FILE:
      return {
        ...state,
        pharmacyFile: action?.data?.pharmacyFile,
      };

    case PharmaciesActionTypes.SET_PHARMACY_TEXT:
      return {
        ...state,
        pharmacyText: action?.data?.pharmacyText,
      };

    case PharmaciesActionTypes.SET_RECIPIENTS_LIST:
      return {
        ...state,
        recipients: {
          ...state.recipients,
          [action?.data?.id]: action?.data?.text,
        },
        recipientsValidation: action?.data?.recipientsValidation && !!action?.data?.text,
      };

    case PharmaciesActionTypes.SET_CLIENT_SUGGESTED_TYPE:
      return {
        ...state,
        clientSuggestedType: action?.data?.clientSuggestedType,
        clientSuggestedTime: undefined,
        clientSuggestedRange: undefined,
      };

    case PharmaciesActionTypes.SET_CLIENT_SUGGESTED_TIME:
      return {
        ...state,
        clientSuggestedTime: action?.data?.clientSuggestedTime,
      };

    case PharmaciesActionTypes.SET_CLIENT_SUGGESTED_RANGE:
      return {
        ...state,
        clientSuggestedRange: action?.data?.clientSuggestedRange,
      };

    case PharmaciesActionTypes.CHECK_DATA_VALIDATION: {
      let recipientsError = false;

      for (const property in state.recipients) {
        // @ts-ignore
        if (!state.recipients[property]) {
          recipientsError = true;
          break;
        }
      }

      return {
        ...state,
        recipientsError: recipientsError,
        dataValidation: false,
      };
    }

    case PharmaciesActionTypes.STORE_UPLOAD_PHARMACY_DATA:
      return {
        ...state,
        storePharmacyLoading: true,
      };

    case PharmaciesActionTypes.SET_STORE_LOADING:
      return {
        ...state,
        storePharmacyLoading: false,
      };

    case PharmaciesActionTypes.SET_NEW_DRUG:

      return {
        ...state,
        otcList: [...state.otcList, {
          name: '',
          key: new Date().getTime(),
          doze: '',
          description: '',
          quantity: '',
          drugTitleFlag: false,
          drugTypeFlag: false,
          drugUnitFlag: false,
          drugQuantityFlag: false,
          type: '',
          unit: '',
          sending_similar: '0',
          isLocked: false,
        }],
        checkDrugLoading: false,
      };

    case PharmaciesActionTypes.DELETE_SELECTED_DRUG: {
      const myArr = JSON.parse(JSON.stringify(state.otcList));

      const index = state.otcList.findIndex(function (list) {
        return list.key === action?.data?.key;
      });

      if (index !== -1) {
        myArr.splice(index, 1);
      }
      saveToLocal('otc_list', JSON.stringify(myArr));
      return {
        ...state,
        otcList: myArr,
      };
    }

    case PharmaciesActionTypes.SET_DRUG_INFO: {
      const myArr = JSON.parse(JSON.stringify(state.otcList));
      for (const obj of myArr) {
        if (obj.key === action?.data?.id) {
          obj[action?.data?.key] = action?.data?.info;
          if (action?.data?.key === 'type') {
            obj.drugTypeFlag = !action?.data?.info;
          }
          if (action?.data?.key === 'unit') {
            obj.drugUnitFlag = !action?.data?.info;
          }
          if (action?.data?.key === 'name') {
            obj.drugTitleFlag = action?.data?.info.length < 3;
          }
          if (action?.data?.key === 'quantity') {
            obj.drugQuantityFlag = !action?.data?.info;
          }
          break;
        }
      }

      return {
        ...state,
        otcList: myArr,
        showBanner: false,
      };
    }

    case PharmaciesActionTypes.STORE_OTC_PHARMACY_DATA:
      return {
        ...state,
        storePharmacyLoading: true,
      };

    case PharmaciesActionTypes.CHECK_CARD_VALIDATION: {
      const temp = JSON.parse(JSON.stringify(state.otcList));
      let flag = false;

      for (const obj of temp) {
        if (obj.name.length < 3) {
          obj.drugTitleFlag = true;
          flag = true;
        }
        if (obj.type === '') {
          obj.drugTypeFlag = true;
          flag = true;
        }
        if (obj.unit === '') {
          obj.drugUnitFlag = true;
          flag = true;
        }
        if (obj.quantity === '') {
          obj.drugQuantityFlag = true;
          flag = true;
        }
      }

      return {
        ...state,
        otcList: temp,
        otcCardFlag: flag,
      };
    }

    case PharmaciesActionTypes.GET_EDIT_IMAGE_FILE:
      return {
        ...state,
        pharmacyEditedImage: action?.data?.pharmacyEditedImage,
        pharmacyEditedImageIndex: action?.data?.pharmacyEditedImageIndex,
      };

    case PharmaciesActionTypes.SET_EDIT_IMAGE_FILE:
      return {
        ...state,
        pharmacyEditedImage: action?.data?.pharmacyEditedImage,
        pharmacyImageLoading: true,
      };

    case PharmaciesActionTypes.INSERT_DRUG_IMAGE: {
      let tempList = JSON.parse(JSON.stringify(state.otcList));
      tempList[state.pharmacyEditedImageIndex] = Object.assign({}, tempList[state.pharmacyEditedImageIndex], {
        attach: { '0': action?.data?.pharmacyEditedImage },
      });
      return {
        ...state,
        otcList: tempList,
        pharmacyEditedImage: initialState.pharmacyEditedImage,
        pharmacyEditedImageIndex: initialState.pharmacyEditedImageIndex,
        pharmacyImageLoading: false,
      };
    }

    case PharmaciesActionTypes.SET_IMAGE_INITIAL:
      return {
        ...state,
        pharmacyImageLoading: false,
        pharmacyEditedImageIndex: initialState.pharmacyEditedImageIndex,
        pharmacyEditedImage: initialState.pharmacyEditedImage,
      };

    case PharmaciesActionTypes.SET_TOP_SALE_DRUG:
      return {
        ...state,
        otcList: [{
          name: action?.data?.name,
          key: new Date().getTime(),
          quantity: '',
          doze: '',
          description: '',
          drugTitleFlag: false,
          drugTypeFlag: false,
          drugUnitFlag: false,
          drugQuantityFlag: false,
          type: '',
          unit: '',
          // type: action?.data?.type,
          // unit: action?.data?.unit,
          sending_similar: '0',
          isLocked: false,
        }],
      };

    case PharmaciesActionTypes.SET_PHARMACY_OTC_FOR_VALIDATION:
    case PharmaciesActionTypes.HANDLE_LOCK_CARD: {
      const otcLists = JSON.parse(JSON.stringify(state.otcList));

      let data;
      for (const obj of otcLists) {
        if (obj.key === action?.data?.id) {
          obj['isLoading'] = true;
          data = obj;
          break;
        }
      }
      return {
        ...state,
        otcValidationId: action?.data?.id,
        otcValidationInfo: data,
      };
    }

    case PharmaciesActionTypes.SET_LOCK_CARD: {
      const myArr = JSON.parse(JSON.stringify(state.otcList));
      for (const obj of myArr) {
        if (obj.key === state.otcValidationId) {
          obj['isLocked'] = action?.data?.isLocked || false;
          obj['isLoading'] = false;
          break;
        }
      }

      return {
        ...state,
        otcList: myArr,
        checkDrugLoading: false,
      };
    }

    case PharmaciesActionTypes.DISABLE_COMPLETE_ORDER: {
      return {
        ...state,
        disableOtcFlag: true,
      };
    }

    case PharmaciesActionTypes.ENABLE_COMPLETE_ORDER: {
      return {
        ...state,
        disableOtcFlag: false,
      };
    }

    case PharmaciesActionTypes.SET_RESIDENCE_CITY:
      return {
        ...state,
        city: action?.data,
      };

    case PharmaciesActionTypes.SET_QUERY_DRUG:
      return {
        ...state,
        otcList: [{
          name: action?.data?.name,
          key: new Date().getTime(),
          quantity: '',
          doze: '',
          description: '',
          drugTitleFlag: false,
          drugTypeFlag: false,
          drugUnitFlag: false,
          drugQuantityFlag: false,
          type: action?.data?.type,
          unit: state.otcList[0].unit,
          sending_similar: '0',
          isLocked: false,
        }],
      };

    case PharmaciesActionTypes.SET_CITY_MODAL:
      return {
        ...state,
        cityModal: action?.data?.open,
        validationType: action?.data?.type || state.validationType,
      };

    case PharmaciesActionTypes.SET_CITY_HREF:
      return {
        ...state,
        cityHref: action?.data?.href,
      };

    case PharmaciesActionTypes.SET_CHECK_DRUG_LOADING:
      return {
        ...state,
        checkDrugLoading: action?.data?.loading,
      };

    case PharmaciesActionTypes.HANDLE_CARD_VALIDATION:
      return {
        ...state,
        checkDrugLoading: true,
      };

    case PharmaciesActionTypes.PHARMACY_DATA_VALIDATION:
      return {
        ...state,
        validationType: action?.data?.type || state.validationType,
      };

    case PharmaciesActionTypes.SET_PHARMACY_LOADING:
      return {
        ...state,
        pharmacyLoading: action?.data?.loading,
      };

    case PharmaciesActionTypes.SET_ELECTRONIC_PRESCRIPTION: {
      let flagType = '';
      let flag = false;
      switch (action?.data?.key) {
        case 'insurance_type': {
          flagType = 'insuranceFlag';
          flag = !action?.data?.data;
          break;
        }
        case 'doctor_name': {
          flagType = 'doctorFlag';
          flag = !action?.data?.data;
          break;
        }
        case 'national_code': {
          flagType = 'nationalFlag';
          flag = !action?.data?.data;
          break;
        }
        case 'tracking_code': {
          flagType = 'trackingFlag';
          flag = !action?.data?.data;
          break;
        }
      }
      return {
        ...state,
        electronicPrescription: {
          ...state.electronicPrescription,
          [action?.data?.key]: action?.data?.data,
          [flagType]: flag,
        },
      };
    }

    case PharmaciesActionTypes.GET_INSURANCE_LIST: {
      return {
        ...state,
        insuranceListLoading: true,
      };
    }

    case PharmaciesActionTypes.SET_INSURANCE_LIST: {
      return {
        ...state,
        insuranceList: action?.data,
        insuranceListLoading: false,
      };
    }

    case PharmaciesActionTypes.CHECK_ELECTRONIC_VALIDATION: {
      const data = JSON.parse(JSON.stringify(state.electronicPrescription));
      let flag = false;
      if (state.electronicPrescription.tracking_code === '') {
        data.trackingFlag = true;
        flag = true;
      }
      if (state.electronicPrescription.national_code === '' || !nationalIdValidation(state.electronicPrescription.national_code)) {
        data.nationalFlag = true;
        flag = true;
      }
      if (state.electronicPrescription.doctor_name === '') {
        data.doctorFlag = true;
        flag = true;
      }
      if (state.electronicPrescription.insurance_type === '') {
        data.insuranceFlag = true;
        flag = true;
      }
      return {
        ...state,
        electronicPrescription: data,
        electronicPrescriptionFlag: flag,
      };
    }

    case PharmaciesActionTypes.SET_OTC_STORAGE_DATA:
      return {
        ...state,
        otcList: action?.data?.otcList,
      };

    case PharmaciesActionTypes.SET_PHARMACY_BANNER:
      return {
        ...state,
        bannerLoading: false,
        bannerPrice: action?.data?.bannerPrice || initialState.bannerPrice,
      };

    case PharmaciesActionTypes.SET_CONSULT_PRESCRIPTION:
      return {
        ...state,
        electronicPrescription: {
          insurance_type: action?.data?.insurance_type,
          doctor_name: action?.data?.doctor_name,
          description: action?.data?.description,
          national_code: action?.data?.national_code,
          tracking_code: action?.data?.tracking_code,
          consult_dialogue_id: action?.data?.consult_dialogue_id,
          doctorFlag: false,
          trackingFlag: false,
          nationalFlag: false,
          insuranceFlag: false,
        },
        validationType: 'electronicPrescription',
      };

    case PharmaciesActionTypes.SET_OTC_QUERY_DATA:
      return {
        ...state,
        otcList: [{
          name: action?.data?.name,
          key: new Date().getTime(),
          quantity: action?.data?.quantity,
          doze: '',
          description: '',
          drugTitleFlag: false,
          drugTypeFlag: false,
          drugUnitFlag: false,
          drugQuantityFlag: false,
          attach: null,
          type: action?.data?.type,
          unit: action?.data?.unit,
          sending_similar: '0',
          isLocked: false,
          isLoading: false,
        }],
      };

    case PharmaciesActionTypes.STORE_ELECTRONIC_PHARMACY_DATA:
      return {
        ...state,
        storePharmacyLoading: true,
      };

    default:
      return state;
  }
}

export default pharmaciesReducer;
